import { getLocale } from "../runtime";

const sv_readmore = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Läs mer`
};

const readmore = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_readmore(inputs)
	return "readMore";
};

export { readmore as "readMore" };